import { plural, t } from "@lingui/macro";
import { deleto, get, post, puto } from 'bukku/shared/ApiService';
import { all, call, delay, fork, put, takeEvery } from 'bukku/shared/SagaService';
import queryString from "query-string";
import { PermissionCheck } from '../../components/Access/helper/permission/PermissionCheck';
import { PermissionKey } from '../../components/Access/helper/permission/enum/PermissionKey';
import { PermissionV2 } from '../../components/Access/helper/permission/enum/PermissionV2';
import { errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn } from "../helper";
import { store } from '../store';
import actions from './actions';
import { BankFeedDummyDatas } from './dummy/BankFeedDummyDatas';
import { BankFeedUseDummy } from './dummy/BankFeedUseDummy';

const apiUrl = process.env.REACT_APP_API_URL;

const successKeys = [
    actions.BANK_FEED_READ_ALL_SUCCESS,
    actions.BANK_FEED_CONNECT_SUCCESS,
    actions.BANK_FEED_DISCONNECT_SUCCESS,
    actions.BANK_FEED_SYNC_SUCCESS,
    actions.BANK_FEED_MAP_ACCOUNTS_SUCCESS,
    actions.BANK_FEED_TRANSACTION_READ_ALL_SUCCESS,
    actions.BANK_FEED_TRANSACTION_DELETE_SUCCESS,
    actions.BANK_FEED_TRANSACTION_BULK_DELETE_SUCCESS,
    actions.BANK_FEED_SMART_RECON_SUCCESS,
];
const errorKeys = [
    actions.BANK_FEED_READ_ALL_ERROR,
    actions.BANK_FEED_CONNECT_ERROR,
    actions.BANK_FEED_DISCONNECT_ERROR,
    actions.BANK_FEED_SYNC_ERROR,
    actions.BANK_FEED_MAP_ACCOUNTS_ERROR,
    actions.BANK_FEED_TRANSACTION_READ_ALL_ERROR,
    actions.BANK_FEED_TRANSACTION_DELETE_ERROR,
    actions.BANK_FEED_TRANSACTION_BULK_DELETE_ERROR,
    actions.BANK_FEED_SMART_RECON_ERROR,
];

const getSuccessMsg = action => {
    const { data, type } = action;
    switch (type) {
        case actions.BANK_FEED_DISCONNECT_SUCCESS:
            return t`Bank feed successfully disconnected.`;
        case actions.BANK_FEED_SYNC_SUCCESS:
            return t`Sync is scheduled. You will get notified when the sync is completed.`;
        // case actions.BANK_FEED_MAP_ACCOUNTS_SUCCESS:
        //     return t`Bank accounts successfully mapped to Bukku.`;
        case actions.BANK_FEED_TRANSACTION_DELETE_SUCCESS:
            return t`The bank feed transaction is successfully deleted.`;
        case actions.BANK_FEED_TRANSACTION_BULK_DELETE_SUCCESS:
            return t`${plural(data.deleted_transaction_ids.length, {
                one: `# bank feed transaction successfully deleted.`,
                other: `# bank feed transactions successfully deleted.`,
            })}`;
        case actions.BANK_FEED_SMART_RECON_SUCCESS:
            return t`Successfully generated bank feed reconciliation statement.`;
        default:
            return null;
    }
};

export function* readAllBankFeedsRequest() {
    yield takeEvery(actions.BANK_FEED_READ_ALL_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ payload }) {
                const useDummyBankFeeds =
                BankFeedUseDummy[actions.BANK_FEED_READ_ALL_REQUEST] ||
                BankFeedUseDummy[actions.BANK_FEED_MAP_ACCOUNTS_REQUEST] ||
                BankFeedUseDummy.BANK_FEED_PENDING_CHECKER;

                let data;
                if (!useDummyBankFeeds) {
                    const response = yield call(get, '/bank_feeds', payload, context);
                    data = yield response.data;
                }
                else {
                    yield delay(1000);
                    data = {
                        bank_feeds: BankFeedDummyDatas[action.type],
                    };
                }

                const hasCreatePermission = PermissionCheck
                    .withKeys(PermissionKey.bank_feed)
                    .hasPermissionTo(PermissionV2.create);

                // OK
                yield put({
                    type: actions.BANK_FEED_READ_ALL_SUCCESS,
                    bank_feeds: data.bank_feeds,
                    hasCreatePermission,
                });
            });
    });
}

export function* connectBankFeedRequest() {
    yield takeEvery(actions.BANK_FEED_CONNECT_REQUEST, function* (action) {
        yield requestSagaPullingFn(action,
            // function* (action) {
            function* ({bankFeedId}) {
                const { Auth } = store.getState();
                const { subdomain, accessToken } = Auth;

                const getRedirectUri = () => {
                    const url = `${apiUrl}/ext/maybank/bank_feed/auth_link`;
                    const params = {
                        cs: subdomain,
                        token: accessToken,
                        bank_feed_id: bankFeedId,
                    };

                    const paramsString = queryString.stringify(params,
                        { arrayFormat: 'bracket', skipNull: true, sort: false },
                    );

                    if (paramsString)
                        return `${url}?${paramsString}`;
                    return url;
                };

                const useDummyConnect = BankFeedUseDummy[actions.BANK_FEED_CONNECT_REQUEST];
                // let data;

                if (!useDummyConnect) {
                    yield window.location.replace(getRedirectUri());
                }
                // yield call(get, '/ext/maybank/bank_feed/auth_link', null, context);
                // data = yield response.data;

                else {
                    yield delay(200);
                    // window.location.replace(getRedirectUri());
                    window.open('https://www.maybank2u.com.my/', '_self');
                    // data = {
                    //     redirect_uri: BankFeedDummyDatas[action.type],
                    // };
                }

                // OK
                yield put({
                    type: actions.BANK_FEED_CONNECT_SUCCESS,
                    // redirect_uri: data.redirect_uri,
                });
            });
    });
}

export function* disconnectBankFeedRequest() {
    yield takeEvery(actions.BANK_FEED_DISCONNECT_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* () {
                const useDummyDisconnect = BankFeedUseDummy[actions.BANK_FEED_DISCONNECT_REQUEST];
                if (!useDummyDisconnect)
                    yield call(post, '/ext/maybank/bank_feed/disconnect', null, context);
                else
                    yield delay(1000);

                // OK
                yield put({
                    type: actions.BANK_FEED_DISCONNECT_SUCCESS,
                });
            });
    });
}

export function* syncBankFeedRequest() {
    yield takeEvery(actions.BANK_FEED_SYNC_REQUEST, function* (action, context) {
        // const notificationKey = notification.open({
        //     message: t`Syncing bank feeds in background`,
        //     description: t`You may continue using Bukku. You will get notified when the sync is completed.`,
        //     duration: 3,
        //     icon: <LoadingOutlined />,
        // });

        try {
            const { bankFeedId } = action;
            const useDummySync = BankFeedUseDummy[actions.BANK_FEED_SYNC_REQUEST];

            if (!useDummySync)
                yield call(post, `/bank_feeds/${bankFeedId}/sync`, null, context);
            else
                yield (delay(1000));

            // OK
            yield put({
                type: actions.BANK_FEED_SYNC_SUCCESS,
                bankFeedId,
            });

            // notification.destroy(notificationKey);
        }
        catch (error) {
            const { bankFeedId } = action;
            yield put({
                type: actions.BANK_FEED_SYNC_ERROR,
                bankFeedId,
                error,
            });
            // notification.destroy(notificationKey);
        }
    });
}

export function* mapAccountRequest() {
    yield takeEvery(actions.BANK_FEED_MAP_ACCOUNTS_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ bankFeedId, request }) {
                const useDummyMapAcc = BankFeedUseDummy[actions.BANK_FEED_MAP_ACCOUNTS_REQUEST];
                if (!useDummyMapAcc)
                    yield call(puto, `/bank_feeds/${bankFeedId}/links`, request, context);
                else
                    yield delay(1000);

                // OK
                yield put({
                    type: actions.BANK_FEED_MAP_ACCOUNTS_SUCCESS,
                });
            });
    });
}

export function* readAllBankFeedTransactionsRequest() {
    yield takeEvery(actions.BANK_FEED_TRANSACTION_READ_ALL_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ bank_feed_id, account_id, payload }) {
                const useDummyBankFeedTrx = BankFeedUseDummy[actions.BANK_FEED_TRANSACTION_READ_ALL_REQUEST];
                let data;
                if (!useDummyBankFeedTrx) {
                    const response = yield call(get,
                        `/bank_feeds/${bank_feed_id}/accounts/${account_id}/transactions`,
                        payload,
                        context);
                    data = yield response.data;
                }
                else {
                    yield delay(1000);
                    data = {
                        transactions: BankFeedDummyDatas[action.type],
                        paging: {
                            total: BankFeedDummyDatas[action.type].length,
                            current_page: Math.ceil(BankFeedDummyDatas[action.type].length / 10),
                            per_page: 10,
                        },
                    };
                }

                // OK
                yield put({
                    type: actions.BANK_FEED_TRANSACTION_READ_ALL_SUCCESS,
                    bank_feed_transactions: data.transactions,
                    pagination: data.paging,
                });
            });
    });
}

export function* deleteBankFeedTransactionRequest() {
    yield takeEvery(actions.BANK_FEED_TRANSACTION_DELETE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ bank_feed_id, account_id, transaction_id }) {
                const useDummyDeleteFeedTrx = BankFeedUseDummy[actions.BANK_FEED_TRANSACTION_DELETE_REQUEST];
                // let data;

                if (!useDummyDeleteFeedTrx) {
                    yield call(deleto,
                        `/bank_feeds/${bank_feed_id}/accounts/${account_id}/transactions/${transaction_id}`,
                        null,
                        context,
                    );
                    // const data = yield response.data;
                }
                else {
                    yield delay(1000);
                }

                // OK
                yield put({
                    type: actions.BANK_FEED_TRANSACTION_DELETE_SUCCESS,
                    // bank_feed_transaction: data.bank_feed_transaction,
                });
            });
    });
}

export function* bulkDeleteBankFeedTransactionRequest() {
    yield takeEvery(actions.BANK_FEED_TRANSACTION_BULK_DELETE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({bank_feed_id, account_id, request }) {
                const useDummyBulkDel = BankFeedUseDummy[actions.BANK_FEED_TRANSACTION_BULK_DELETE_REQUEST];
                // let data;
                if (!useDummyBulkDel)
                    yield call(post, `/bank_feeds/${bank_feed_id}/accounts/${account_id}/transactions/delete`, request, context);
                    // data = yield response.data;
                else
                    yield delay(1000);

                // OK
                yield put({
                    type: actions.BANK_FEED_TRANSACTION_BULK_DELETE_SUCCESS,
                    data: {
                        deleted_transaction_ids: request.transaction_ids,
                    },
                    // deleted_feed_ids: data.feed_ids,
                    // bank_feed_transactions: data.bank_feed_transactions,
                    // pagination: data.paging,
                });
            });
    });
}

export function* performBankFeedSmartReconRequest() {
    yield takeEvery(actions.BANK_FEED_SMART_RECON_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request }) {
                const useDummyBankFeedRecon = BankFeedUseDummy[actions.BANK_FEED_SMART_RECON_REQUEST];
                let data;
                if (!useDummyBankFeedRecon) {
                    const response = yield call(post, `/reconciliations/mbb_statements`, request, context);
                    data = yield response.data;
                }
                else {
                    yield delay(2000);
                    data = BankFeedDummyDatas[action.type];
                }

                // OK
                yield put({
                    type: actions.BANK_FEED_SMART_RECON_SUCCESS,
                    statement: data.statement,
                });
            });
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),

        fork(readAllBankFeedsRequest),

        fork(connectBankFeedRequest),
        fork(disconnectBankFeedRequest),
        fork(syncBankFeedRequest),
        fork(mapAccountRequest),

        fork(readAllBankFeedTransactionsRequest),
        fork(deleteBankFeedTransactionRequest),
        fork(bulkDeleteBankFeedTransactionRequest),

        fork(performBankFeedSmartReconRequest),
    ]);
}
